import { useState } from 'react';

function useDropdownSelect<T>() {
  const [selectedOption, setSelectedOption] = useState<T>();

  const handleSelectChange = (value: T) => {
    if (value) {
      setSelectedOption(value);
    }
  };

  return { selectedOption, handleSelectChange };
}

export default useDropdownSelect;
